import React, { useState, useCallback, useEffect } from 'react';
import PageTitle from 'components/Additional/PageElements/PageTitle/PageTitle';
import coveragesHelper from './CoveragesHelper';

import 'components/styles/styles.css';
import styles from './CoveragesForQuote.module.css';

const CoveragesForQuote = ({ calculations }) => {
	const [mobileTooltipActive, setMobileTooltipActive] = useState(false);

	const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

	const handleTooltipClick = useCallback(
		(e) => {
			if (isMobile) {
				e.preventDefault();
				e.stopPropagation();
				setMobileTooltipActive((prev) => !prev);
			}
		},
		[isMobile],
	);

	useEffect(() => {
		if (!mobileTooltipActive) return;
		const handleClose = () => setMobileTooltipActive(false);
		document.addEventListener('click', handleClose);
		return () => document.removeEventListener('click', handleClose);
	}, [mobileTooltipActive]);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<PageTitle
				titleContent={
					<>
						Estimated Monthly Premium:{' '}
						{coveragesHelper.formatNumber(
							coveragesHelper.calculateMonthlyPremium(
								calculations.premiumAmountAndFees,
							),
						)}
						<br />
					</>
				}
			/>
			<div className={styles.estimated_text_container}>
				<p className={styles.estimated_text}>
					Estimated Annual Premium:{' '}
					{coveragesHelper.formatNumber(
						calculations.premiumAmountAndFees,
					)}
				</p>
				<p className={styles.estimated_text}>
					{`Quote Number: ${calculations.quoteNumber}`}
				</p>
			</div>
			<div className={styles.title_container}>
				<div className={styles.title_with_tooltip}>
					<span className={styles.title_label}>Coverage Details</span>
					<div
						className={`${styles.info_icon_coverages} ${styles.tooltip_top} ${mobileTooltipActive ? styles.mobile_tooltip_active : ''}`}
						data-tooltip="The estimate returned assumes an excellent insurance score and applies common coverage options. The coverages and deductibles can be customized to meet your needs and budget."
						onClick={handleTooltipClick}
					></div>
				</div>
				{calculations.docUrl && (
					<div className={styles.print_link_container}>
						<a
							href={calculations.docUrl}
							download
							target="_blank"
							className={styles.print_link}
						>
							Print Quote
						</a>
					</div>
				)}
			</div>
			<div className={styles.expandable_content}>
				<div className={styles.content_container}>
					<div className={styles.coverage_row}>
						<span>
							<h4>COVERAGE</h4>
						</span>
						<span>
							<h4>LIMIT</h4>
						</span>
					</div>
					{calculations.limits.map((item, index) => (
						<div key={index} className={styles.coverage_row}>
							<span
								style={{
									color: 'black',
								}}
							>
								{item.label}
							</span>
							<span className={styles.value_bold}>
								{item.value}
							</span>
						</div>
					))}
					<div className={styles.vDivider} />
					{calculations.deductibles.map((item, index) => (
						<div key={index} className={styles.coverage_row}>
							<span
								style={{
									color: 'black',
								}}
							>
								{item.label}
							</span>
							<span className={styles.value_bold}>
								{item.value}
							</span>
						</div>
					))}
					<div className={styles.vDivider} />
					<div>
						<b>
							<h4>ADDITIONAL COVERAGES INCLUDED:</h4>
						</b>
					</div>
					{calculations.additionalCoverages.map((item, index) => (
						<div key={index} className={styles.coverage_row}>
							<span
								style={{
									color: 'black',
								}}
							>
								{item.label}
							</span>
							<span className={styles.value_bold}>
								{item.value}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default CoveragesForQuote;
